export interface ProductSpec {
  label: string;
  value: string;
}

export interface Product {
  id: string;
  name: string;
  category: string;
  categorySlug: string;
  shortDesc: string;
  longDesc: string;
  price: string;
  image: string;
  gallery: string[];
  specs: ProductSpec[];
  features: string[];
  benefits: { icon: string; title: string; desc: string }[];
  isFeatured: boolean;
}

export const products: Product[] = [
  {
    id: "ip-kamera-4k-pro",
    name: "IP Kamera 4K Pro",
    category: "Kamere",
    categorySlug: "kamere",
    shortDesc: "Profesionalna 4K IP kamera sa naprednom AI detekcijom pokreta i noćnim vidom do 50m.",
    longDesc: "IP Kamera 4K Pro predstavlja vrhunac tehnologije video nadzora. Sa Ultra HD rezolucijom 3840×2160, naprednom AI analitikom koja razlikuje lica, vozila i objekte, i IP67 vodootpornim kućištem — ova kamera je projektovana za najzahtevnije profesionalne primene. Bilo da štitite poslovni objekat, skladište ili stambeni kompleks, 4K Pro pruža beskompromisan kvalitet slike i pouzdanost u svim vremenskim uslovima.",
    price: "34,990 RSD",
    image: "https://rs-mangoshop.com/cdn/shop/files/A6_b138167d-be1c-4680-8efa-7b25736fc842.png?v=1723421250&width=823",
    gallery: [
      "https://readdy.ai/api/search-image?query=4K%20IP%20security%20camera%20mounted%20on%20modern%20building%20exterior%20wall%2C%20professional%20surveillance%20installation%2C%20clean%20architectural%20setting%2C%20daylight%20scene%2C%20minimalist%20commercial%20photography%2C%20showing%20scale%20and%20placement&width=800&height=800&seq=prod-4k-pro-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20detail%20of%204K%20security%20camera%20lens%20and%20sensors%2C%20dark%20metallic%20texture%2C%20precision%20engineering%20aesthetic%2C%20clean%20studio%20background%2C%20technical%20product%20photography%2C%20sharp%20focus%20on%20lens%20elements&width=800&height=800&seq=prod-4k-pro-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Security%20camera%20night%20vision%20demonstration%2C%20dark%20scene%20with%20infrared%20illumination%2C%20professional%20surveillance%20setup%2C%20monitoring%20perimeter%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20cinematic%20security%20photography&width=800&height=800&seq=prod-4k-pro-g3&orientation=squarish",
    ],
    specs: [
      { label: "Rezolucija", value: "4K Ultra HD (3840×2160)" },
      { label: "Noćni vid", value: "Do 50m IR LED" },
      { label: "AI Detekcija", value: "Lice, vozila, zone" },
      { label: "IP zaštita", value: "IP67 vodootporna" },
      { label: "Ugao gledanja", value: "110° širokougaona" },
      { label: "Skladištenje", value: "MicroSD do 256GB" },
    ],
    features: [
      "AI detekcija lica i vozila",
      "Dvosmerni audio sa noise-cancelling",
      "PoE napajanje (Power over Ethernet)",
      "ONVIF kompatibilnost",
      "Mobilna aplikacija za iOS i Android",
    ],
    benefits: [
      { icon: "ri-shield-check-line", title: "IP67 sertifikacija", desc: "Vodootporna i otporna na prašinu, radi u svim vremenskim uslovima od -30°C do +60°C." },
      { icon: "ri-eye-line", title: "Noćni vid 50m", desc: "Ultra-jasne slike i u potpunom mraku zahvaljujući naprednim IR LED diodama." },
      { icon: "ri-brain-line", title: "AI analitika", desc: "Automatska detekcija lica, vozila i sumnjivih aktivnosti sa trenutnim obaveštenjima." },
    ],
    isFeatured: true,
  },
  {
    id: "ip-kamera-dome",
    name: "IP Kamera Dome",
    category: "Kamere",
    categorySlug: "kamere",
    shortDesc: "Diskretna dome kamera za unutrašnju i spoljnu montažu sa 360° panoramskim pregledom.",
    longDesc: "IP Kamera Dome kombinuje diskretan dizajn sa moćnim performansama. Sa 5MP rezolucijom, 360° rotacijom i IK10 anti-vandal kućištem, idealna je za hotele, restorane, kancelarije i maloprodajne objekte gde je estetika jednako važna kao i bezbednost. WDR tehnologija osigurava kristalno jasnu sliku i u izazovnim svetlosnim uslovima.",
    price: "27,990 RSD",
    image: "https://rs-mangoshop.com/cdn/shop/files/A4_c5faf868-d029-457c-83e2-f5b039c167db.png?v=1723421256&width=823",
    gallery: [
      "https://readdy.ai/api/search-image?query=Dome%20security%20camera%20installed%20on%20modern%20office%20ceiling%2C%20discreet%20surveillance%2C%20clean%20corporate%20interior%2C%20minimalist%20design%2C%20professional%20commercial%20photography%2C%20blending%20into%20architecture&width=800&height=800&seq=prod-dome-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20detail%20of%20dome%20security%20camera%20housing%2C%20dark%20metallic%20finish%2C%20premium%20build%20quality%2C%20vandal-resistant%20design%2C%20clean%20studio%20background%2C%20technical%20product%20photography&width=800&height=800&seq=prod-dome-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Dome%20camera%20monitoring%20lobby%20or%20reception%20area%2C%20warm%20indoor%20lighting%2C%20professional%20environment%2C%20surveillance%20in%20action%2C%20commercial%20security%20scene%2C%20clean%20interior%20photography&width=800&height=800&seq=prod-dome-g3&orientation=squarish",
    ],
    specs: [
      { label: "Rezolucija", value: "5MP (2592×1944)" },
      { label: "Noćni vid", value: "Do 30m IR LED" },
      { label: "Rotacija", value: "Pan 360° / Tilt 90°" },
      { label: "IP zaštita", value: "IP66 otporna" },
      { label: "Vandal", value: "IK10 anti-vandal" },
      { label: "Skladištenje", value: "MicroSD do 128GB" },
    ],
    features: [
      "360° neprekidna rotacija",
      "Vandal-proof IK10 kućište",
      "WDR (Wide Dynamic Range)",
      "3D DNR redukcija šuma",
      "Podrška za PoE",
    ],
    benefits: [
      { icon: "ri-shield-flash-line", title: "IK10 anti-vandal", desc: "Otporna na fizičke udare i vandalizam. Idealna za javne površine i prometne lokacije." },
      { icon: "ri-contrast-line", title: "WDR tehnologija", desc: "Wide Dynamic Range osigurava jasnu sliku u prostorima sa jakim kontrastom svetla i senke." },
      { icon: "ri-eye-2-line", title: "360° pokrivenost", desc: "Potpuna pokrivenost bez mrtvih uglova sa pan i tilt kontrolom u realnom vremenu." },
    ],
    isFeatured: true,
  },
  {
    id: "ip-kamera-bullet",
    name: "IP Kamera Bullet",
    category: "Kamere",
    categorySlug: "kamere",
    shortDesc: "Robusna bullet kamera za spoljnu montažu sa ultra-zumom i pametnim praćenjem objekata.",
    longDesc: "IP Kamera Bullet je projektovana za spoljni nadzor velikih površina. Sa optičkim zumom 5x, digitalnim 16x i automatskim praćenjem objekata, ova kamera ne propušta ni najmanji detalj. Robusno IP67 kućište, audio alarm i ugrađena sirena čine je idealnim izborom za perimetarsku zaštitu industrijskih objekata, parkinga i skladišta.",
    price: "31,990 RSD",
    image: "https://rs-mangoshop.com/cdn/shop/files/Ip_kamera_PTZ_kamera_2_-_rs-mangoshop.com.png?v=1773059632&width=823",
    gallery: [
      "https://readdy.ai/api/search-image?query=Bullet%20security%20camera%20mounted%20on%20outdoor%20wall%20overlooking%20parking%20lot%2C%20professional%20surveillance%20installation%2C%20daylight%20scene%2C%20industrial%20setting%2C%20perimeter%20protection%2C%20clean%20architectural%20photography&width=800&height=800&seq=prod-bullet-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20of%20bullet%20camera%20zoom%20lens%20mechanism%2C%20precision%20optics%2C%20dark%20metallic%20finish%2C%20weather-sealed%20construction%2C%20clean%20studio%20background%2C%20technical%20product%20detail%20photography&width=800&height=800&seq=prod-bullet-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Bullet%20camera%20active%20surveillance%20at%20dusk%2C%20industrial%20perimeter%20protection%2C%20moody%20evening%20lighting%2C%20security%20monitoring%20in%20action%2C%20professional%20outdoor%20scene%2C%20atmospheric%20commercial%20photography&width=800&height=800&seq=prod-bullet-g3&orientation=squarish",
    ],
    specs: [
      { label: "Rezolucija", value: "5MP (2592×1944)" },
      { label: "Zum", value: "Optički 5x, digitalni 16x" },
      { label: "Noćni vid", value: "Do 60m IR LED" },
      { label: "IP zaštita", value: "IP67 vodootporna" },
      { label: "Praćenje", value: "Auto-tracking objekata" },
      { label: "Skladištenje", value: "MicroSD do 256GB" },
    ],
    features: [
      "Optički zum 5x sa autofokusom",
      "Smart auto-tracking",
      "Strobe svetlo i sirena",
      "Audio alarm upozorenje",
      "IP67 za ekstremne uslove",
    ],
    benefits: [
      { icon: "ri-zoom-in-line", title: "Optički zum 5x", desc: "Jasan prikaz detalja na velikim udaljenostima bez gubitka kvaliteta slike." },
      { icon: "ri-radar-line", title: "Auto-tracking", desc: "Automatsko praćenje objekata u pokretu — idealno za perimetarsku zaštitu." },
      { icon: "ri-alert-line", title: "Aktivni alarm", desc: "Ugrađeno strobe svetlo i sirena za trenutno odvraćanje neovlašćenih lica." },
    ],
    isFeatured: false,
  },
  {
    id: "video-zvono-wifi",
    name: "Video Zvono WiFi",
    category: "Video zvona",
    categorySlug: "video-zvona",
    shortDesc: "Pametno video zvono sa WiFi konekcijom, dvosmernim audio pozivom i AI detekcijom posetilaca.",
    longDesc: "Video Zvono WiFi donosi potpunu kontrolu nad vašim ulaznim vratima direktno na vaš pametni telefon. Sa 2K rezolucijom, AI detekcijom lica i paketa, dvosmernim audio pozivom i noćnim vidom u boji — uvek znate ko je ispred vaših vrata, čak i kada niste kod kuće. Kompatibilno sa Alexa i Google Assistant ekosistemom.",
    price: "19,990 RSD",
    image: "https://rs-mangoshop.com/cdn/shop/files/Ip_kamera_PTZ_kamera_5_-_rs-mangoshop.com.png?v=1773059751&width=823",
    gallery: [
      "https://readdy.ai/api/search-image?query=Smart%20video%20doorbell%20installed%20next%20to%20modern%20front%20door%2C%20stylish%20residential%20entrance%2C%20daylight%20scene%2C%20contemporary%20home%20exterior%2C%20clean%20architectural%20photography%2C%20smart%20home%20lifestyle&width=800&height=800&seq=prod-doorbell-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Person%20using%20smartphone%20app%20to%20view%20video%20doorbell%20feed%2C%20modern%20living%20room%20setting%2C%20warm%20indoor%20lighting%2C%20connected%20home%20technology%2C%20lifestyle%20photography%2C%20casual%20premium%20aesthetic&width=800&height=800&seq=prod-doorbell-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Video%20doorbell%20night%20mode%20with%20color%20night%20vision%2C%20front%20porch%20illuminated%2C%20warm%20evening%20atmosphere%2C%20smart%20security%20device%20in%20action%2C%20residential%20setting%2C%20cozy%20home%20photography&width=800&height=800&seq=prod-doorbell-g3&orientation=squarish",
    ],
    specs: [
      { label: "Rezolucija", value: "2K (2560×1440)" },
      { label: "WiFi", value: "Dual-band 2.4/5GHz" },
      { label: "Audio", value: "Dvosmerni sa echo-cancel" },
      { label: "AI Detekcija", value: "Lice, paketi, vozila" },
      { label: "IP zaštita", value: "IP65 vodootporno" },
      { label: "Napajanje", value: "Baterija + žično" },
    ],
    features: [
      "2K rezolucija sa HDR",
      "Noćni vid u boji",
      "AI detekcija paketa",
      "Brz odziv < 2 sekunde",
      "Kompatibilno sa Alexa/Google",
    ],
    benefits: [
      { icon: "ri-smartphone-line", title: "Mobilna aplikacija", desc: "Pogledajte ko je na vratima u realnom vremenu sa bilo kog mesta preko iOS i Android aplikacije." },
      { icon: "ri-moon-line", title: "Noćni vid u boji", desc: "Jasna slika u boji i noću zahvaljujući ugrađenom reflektorom sa mekim osvetljenjem." },
      { icon: "ri-chat-3-line", title: "Dvosmerni audio", desc: "Razgovarajte sa posetiocima direktno preko telefona sa kristalno jasnim zvukom." },
    ],
    isFeatured: true,
  },
  {
    id: "video-interfon-7",
    name: "Video Interfon 7\"",
    category: "Video interfoni",
    categorySlug: "video-interfoni",
    shortDesc: "Sistem video interfona sa 7\" ekranom osetljivim na dodir, WiFi konekcijom i daljinskim otključavanjem.",
    longDesc: "Video Interfon 7\" je elegantno rešenje za kontrolu pristupa u stambenim i poslovnim objektima. Sa 7-inčnim IPS ekranom na dodir, ugrađenom WiFi konekcijom i naprednim funkcijama daljinskog otključavanja — pruža potpunu sigurnost bez kompromisa po pitanju dizajna. Podržava do 4 dodatna interna monitora za veće objekte.",
    price: "44,990 RSD",
    image: "https://rs-mangoshop.com/cdn/shop/files/Ip_kamera_PTZ_kamera_8_-_rs-mangoshop.com.png?v=1773059782&width=823",
    gallery: [
      "https://readdy.ai/api/search-image?query=Video%20intercom%20installed%20on%20interior%20wall%20of%20modern%20apartment%2C%20touch%20screen%20display%20showing%20visitor%2C%20clean%20contemporary%20interior%2C%20smart%20home%20technology%2C%20lifestyle%20photography%2C%20warm%20indoor%20lighting&width=800&height=800&seq=prod-intercom7-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=External%20door%20station%20of%20video%20intercom%20system%20mounted%20next%20to%20modern%20entrance%2C%20sleek%20metallic%20finish%2C%20clean%20building%20facade%2C%20daylight%2C%20professional%20architectural%20photography&width=800&height=800&seq=prod-intercom7-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Resident%20using%20smartphone%20to%20remotely%20unlock%20door%20via%20intercom%20app%2C%20modern%20living%20environment%2C%20connected%20home%20security%2C%20casual%20lifestyle%20photography%2C%20warm%20natural%20lighting&width=800&height=800&seq=prod-intercom7-g3&orientation=squarish",
    ],
    specs: [
      { label: "Ekran", value: "7\" IPS Touch (1024×600)" },
      { label: "Kamera", value: "2MP širokougaona" },
      { label: "WiFi", value: "802.11 b/g/n" },
      { label: "Otključavanje", value: "Daljinsko + RFID" },
      { label: "Snimanje", value: "Foto + video poziva" },
      { label: "Aplikacija", value: "iOS / Android" },
    ],
    features: [
      "7\" IPS ekran na dodir",
      "Noćni vid kamere",
      "WiFi konekcija bez kablova",
      "Daljinsko otključavanje vrata",
      "Do 4 dodatna monitora",
    ],
    benefits: [
      { icon: "ri-smartphone-line", title: "IPS Touch ekran", desc: "Osetljiv na dodir, jasan iz svih uglova. Intuitivan interfejs za svakodnevnu upotrebu." },
      { icon: "ri-lock-unlock-line", title: "Daljinsko otključavanje", desc: "Otključajte vrata sa bilo kog mesta putem mobilne aplikacije ili sa ekrana." },
      { icon: "ri-stack-line", title: "Proširiv sistem", desc: "Povežite do 4 interna monitora i 2 spoljne jedinice za kompletnu pokrivenost objekta." },
    ],
    isFeatured: true,
  },
  {
    id: "video-interfon-10",
    name: "Video Interfon 10\"",
    category: "Video interfoni",
    categorySlug: "video-interfoni",
    shortDesc: "Premium video interfon sa 10\" Full HD ekranom, Ethernet konekcijom i integracijom pametne kuće.",
    longDesc: "Video Interfon 10\" je flagship model za najzahtevnije korisnike. Sa ogromnim 10-inčnim Full HD IPS ekranom, HDR kamerom od 5MP i naprednom integracijom KNX sistema pametne kuće — ovo nije samo interfon, već komandni centar vaše kuće. Cloud storage, WiFi 6 i podrška za do 8 spoljnih jedinica čine ga spremnim i za najveće objekte.",
    price: "69,990 RSD",
    image: "https://rs-mangoshop.com/cdn/shop/files/Kamera_sa_monitorom_-_rs-mangoshop.com1.jpg?v=1736865394&width=823",
    gallery: [
      "https://readdy.ai/api/search-image?query=Large%2010%20inch%20video%20intercom%20mounted%20on%20luxury%20apartment%20wall%2C%20display%20showing%20visitor%20feed%2C%20premium%20interior%20design%2C%20warm%20ambient%20lighting%2C%20high-end%20smart%20home%20technology%2C%20lifestyle%20photography&width=800&height=800&seq=prod-intercom10-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20of%2010%20inch%20intercom%20touch%20screen%20interface%20with%20smart%20home%20controls%2C%20glossy%20glass%20display%2C%20premium%20UI%20design%2C%20clean%20background%2C%20futuristic%20technology%20photography&width=800&height=800&seq=prod-intercom10-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Luxury%20modern%20villa%20entrance%20with%20external%20intercom%20door%20station%2C%20grand%20entrance%20design%2C%20daylight%20scene%2C%20premium%20residential%20architecture%2C%20clean%20exterior%20photography%2C%20sophisticated%20aesthetic&width=800&height=800&seq=prod-intercom10-g3&orientation=squarish",
    ],
    specs: [
      { label: "Ekran", value: "10\" Full HD IPS Touch" },
      { label: "Kamera", value: "5MP sa HDR" },
      { label: "Mreža", value: "Ethernet + WiFi 6" },
      { label: "Pametna kuća", value: "KNX / RTSP integracija" },
      { label: "Snimanje", value: "Cloud + lokalno" },
      { label: "Aplikacija", value: "iOS / Android / Web" },
    ],
    features: [
      "10\" Full HD ekran",
      "HDR kamera 5MP",
      "Integracija KNX sistema",
      "Cloud storage uključen",
      "Do 8 spoljnih jedinica",
    ],
    benefits: [
      { icon: "ri-home-4-line", title: "Pametna integracija", desc: "Povežite sa KNX sistemom za potpunu kontrolu rasvete, grejanja i roletni sa jednog ekrana." },
      { icon: "ri-cloud-line", title: "Cloud storage", desc: "Svi video pozivi se automatski čuvaju u cloud-u. Pristupite istoriji sa bilo kog uređaja." },
      { icon: "ri-building-2-line", title: "Do 8 eksternih jedinica", desc: "Skalabilno rešenje za velike stambene zgrade, poslovne komplekse i hotele." },
    ],
    isFeatured: true,
  },
  {
    id: "kontroler-rfid",
    name: "Kontroler Pristupa RFID",
    category: "Kontrola pristupa",
    categorySlug: "kontrola-pristupa",
    shortDesc: "Profesionalni RFID kontroler pristupa za do 10,000 korisnika sa TCP/IP komunikacijom i softverom.",
    longDesc: "RFID Kontroler Pristupa je profesionalno rešenje za upravljanje ulazima u poslovnim zgradama, parkinzima, sportskim centrima i stambenim kompleksima. Podržava do 10,000 korisnika, EM i Mifare kartice, TCP/IP komunikaciju i dolazi sa kompletnim softverom za upravljanje u realnom vremenu. Anti-passback funkcija sprečava zloupotrebu propusnica.",
    price: "24,990 RSD",
    image: "https://readdy.ai/api/search-image?query=Professional%20RFID%20access%20control%20reader%20with%20modern%20black%20design%2C%20wall-mounted%20security%20device%2C%20isolated%20on%20clean%20studio%20background%2C%20minimalist%20product%20photography%2C%20commercial%20security%20equipment&width=800&height=800&seq=prod-rfid&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=RFID%20access%20control%20reader%20installed%20on%20modern%20office%20wall%20next%20to%20glass%20door%2C%20employee%20badge%20scanning%2C%20corporate%20environment%2C%20clean%20professional%20interior%2C%20daylight%2C%20commercial%20security%20photography&width=800&height=800&seq=prod-rfid-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20of%20RFID%20card%20being%20scanned%20on%20access%20reader%2C%20LED%20indicator%20lighting%20up%20green%2C%20modern%20security%20technology%2C%20clean%20background%2C%20technical%20product%20detail%20photography&width=800&height=800&seq=prod-rfid-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Access%20control%20management%20software%20dashboard%20on%20laptop%20screen%2C%20modern%20office%20desk%20setup%2C%20security%20monitoring%20interface%2C%20warm%20indoor%20lighting%2C%20professional%20technology%20photography&width=800&height=800&seq=prod-rfid-g3&orientation=squarish",
    ],
    specs: [
      { label: "Korisnici", value: "Do 10,000 kartica" },
      { label: "Čitač", value: "125kHz EM + 13.56MHz Mifare" },
      { label: "Komunikacija", value: "TCP/IP + RS-485" },
      { label: "Logovi", value: "100,000 događaja" },
      { label: "Softver", value: "Desktop + Web panel" },
      { label: "IP zaštita", value: "IP65" },
    ],
    features: [
      "Do 10,000 korisnika",
      "Podrška za EM i Mifare kartice",
      "TCP/IP mrežno povezivanje",
      "Anti-passback funkcija",
      "Web panel za upravljanje",
    ],
    benefits: [
      { icon: "ri-group-line", title: "10,000+ korisnika", desc: "Skalirajte sistem po potrebi. Idealno za velike organizacije, zgrade i komplekse." },
      { icon: "ri-computer-line", title: "Web upravljanje", desc: "Upravljajte svim vratima i korisnicima sa jednog mesta preko intuitivnog web interfejsa." },
      { icon: "ri-history-line", title: "Detaljni logovi", desc: "100,000 događaja u memoriji. Potpuna istorija svakog prolaska kroz sve kontrolisane ulaze." },
    ],
    isFeatured: true,
  },
  {
    id: "pametna-brava",
    name: "Pametna Brava",
    category: "Kontrola pristupa",
    categorySlug: "kontrola-pristupa",
    shortDesc: "Smart lock sa višestrukim načinima otključavanja: otisak prsta, PIN kod, RFID kartica i mobilna aplikacija.",
    longDesc: "Pametna Brava eliminiše potrebu za ključevima — zauvek. Sa četiri načina otključavanja (otisak prsta, PIN, RFID kartica, mobilna aplikacija), automatskim zaključavanjem, BLE 5.0 mobilnom aplikacijom i anti-panic izlazom, ova brava kombinuje vrhunsku bezbednost sa neverovatnom praktičnošću. Kućište od cink legure i kaljeno staklo garantuju dugotrajnost i premium izgled.",
    price: "29,990 RSD",
    image: "https://readdy.ai/api/search-image?query=Smart%20door%20lock%20with%20fingerprint%20sensor%2C%20modern%20black%20matte%20finish%2C%20isolated%20on%20clean%20studio%20background%2C%20minimalist%20product%20photography%2C%20premium%20smart%20home%20security%20device&width=800&height=800&seq=prod-smartlock&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Smart%20lock%20installed%20on%20modern%20apartment%20door%2C%20stylish%20black%20matte%20finish%2C%20contemporary%20interior%20design%2C%20daylight%20scene%2C%20premium%20residential%20setting%2C%20smart%20home%20lifestyle%20photography&width=800&height=800&seq=prod-smartlock-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20of%20finger%20touching%20smart%20lock%20fingerprint%20sensor%2C%20LED%20indicator%20lighting%2C%20modern%20security%20technology%2C%20clean%20background%2C%20premium%20dark%20finish%2C%20technical%20product%20detail&width=800&height=800&seq=prod-smartlock-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Person%20unlocking%20door%20with%20smartphone%20app%20at%20night%2C%20modern%20home%20entrance%2C%20warm%20exterior%20lighting%2C%20connected%20home%20security%2C%20convenient%20lifestyle%20photography&width=800&height=800&seq=prod-smartlock-g3&orientation=squarish",
    ],
    specs: [
      { label: "Otključavanje", value: "Otisak + PIN + RFID + App" },
      { label: "Korisnici", value: "100 otisaka / 300 PIN" },
      { label: "Baterija", value: "Li-ion 5000mAh" },
      { label: "Materijal", value: "Cink legura + kaljeno staklo" },
      { label: "Bezbednost", value: "Anti-panic + anti-pick" },
      { label: "Aplikacija", value: "iOS / Android BLE 5.0" },
    ],
    features: [
      "4 načina otključavanja",
      "Auto-lock tajmer",
      "BLE 5.0 mobilna aplikacija",
      "Anti-panic izlaz",
      "Alarm nasilnog otvaranja",
    ],
    benefits: [
      { icon: "ri-fingerprint-line", title: "4 u 1 otključavanje", desc: "Otisak prsta, PIN kod, RFID kartica ili mobilna aplikacija — izaberite šta vam odgovara." },
      { icon: "ri-timer-line", title: "Auto-lock", desc: "Brava se automatski zaključava nakon ulaska. Podesivi tajmer od 5 do 60 sekundi." },
      { icon: "ri-error-warning-line", title: "Anti-panic izlaz", desc: "U slučaju nužde, brava se otvara jednim pokretom iznutra — bezbednost na prvom mestu." },
    ],
    isFeatured: true,
  },
  {
    id: "alarmni-sistem",
    name: "Alarmni Sistem Pro",
    category: "Alarmni sistemi",
    categorySlug: "alarmni-sistemi",
    shortDesc: "Kompletan bežični alarmni sistem sa 20 zona, mobilnim obaveštenjima i integracijom kamera.",
    longDesc: "Alarmni Sistem Pro je kompletno bežično rešenje za zaštitu vašeg doma ili poslovnog prostora. Sa 20 bežičnih zona, GSM 4G backup konekcijom, 120dB sirenom i integracijom sa IP kamerama — pruža potpunu zaštitu 24/7. Push notifikacije na vaš telefon osiguravaju da ste uvek obavešteni, a backup baterija od 12 sati garantuje rad i tokom nestanka struje.",
    price: "39,990 RSD",
    image: "https://readdy.ai/api/search-image?query=Complete%20wireless%20alarm%20system%20kit%20with%20modern%20black%20control%20panel%20and%20sensors%2C%20isolated%20on%20clean%20studio%20background%2C%20professional%20product%20photography%2C%20security%20system%20aesthetic&width=800&height=800&seq=prod-alarm&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Alarm%20system%20control%20panel%20mounted%20on%20modern%20home%20wall%2C%20touch%20screen%20display%2C%20contemporary%20interior%2C%20daylight%2C%20smart%20home%20security%2C%20clean%20residential%20photography&width=800&height=800&seq=prod-alarm-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Wireless%20alarm%20sensors%20placed%20on%20modern%20windows%20and%20doors%2C%20minimalist%20home%20interior%2C%20discreet%20security%20devices%2C%20clean%20daylight%20photography%2C%20residential%20safety%20aesthetic&width=800&height=800&seq=prod-alarm-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Smartphone%20showing%20alarm%20system%20notification%20and%20camera%20feed%2C%20modern%20living%20room%20background%2C%20warm%20evening%20lighting%2C%20connected%20home%20security%2C%20lifestyle%20technology%20photography&width=800&height=800&seq=prod-alarm-g3&orientation=squarish",
    ],
    specs: [
      { label: "Zone", value: "20 bežičnih zona" },
      { label: "Senzori", value: "PIR + magnetni + dimni" },
      { label: "Komunikacija", value: "WiFi + GSM 4G" },
      { label: "Sirena", value: "120dB unutrašnja + spoljna" },
      { label: "Baterija", value: "Backup 12h" },
      { label: "Aplikacija", value: "iOS / Android push" },
    ],
    features: [
      "20 bežičnih zona",
      "GSM 4G backup komunikacija",
      "Push notifikacije",
      "Integracija IP kamera",
      "Do 50 korisničkih kodova",
    ],
    benefits: [
      { icon: "ri-signal-wifi-line", title: "Potpuno bežični", desc: "Nema kablova, nema bušenja. Jednostavna instalacija i proširivanje sistema po potrebi." },
      { icon: "ri-signal-tower-line", title: "GSM 4G backup", desc: "Alarmni sistem nastavlja da radi čak i kada internet ili struja nisu dostupni." },
      { icon: "ri-notification-3-line", title: "Push notifikacije", desc: "Instant obaveštenja na vaš telefon za svaki alarmni događaj — uvek ste u toku." },
    ],
    isFeatured: true,
  },
  {
    id: "nvr-rekorder-8ch",
    name: "NVR Rekorder 8CH",
    category: "Sistemi za snimanje",
    categorySlug: "sistemi-za-snimanje",
    shortDesc: "Mrežni video rekorder za 8 kamera sa 4K podrškom, 2 HDD slota i AI analitikom u realnom vremenu.",
    longDesc: "NVR Rekorder 8CH je centralni mozak vašeg video nadzora. Podržava do 8 IP kamera u 4K rezoluciji, poseduje 2 SATA slota za HDD do ukupno 20TB i ugrađenu AI analitiku koja obrađuje video u realnom vremenu. H.265+ kompresija smanjuje potreban prostor za skladištenje do 60% u odnosu na standardne formate.",
    price: "54,990 RSD",
    image: "https://readdy.ai/api/search-image?query=Professional%20NVR%20network%20video%20recorder%20with%20modern%20black%20design%2C%20surveillance%20recording%20device%2C%20isolated%20on%20clean%20studio%20background%2C%20minimalist%20product%20photography%2C%20security%20equipment&width=800&height=800&seq=prod-nvr&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=NVR%20security%20recorder%20installed%20in%20server%20rack%20with%20other%20networking%20equipment%2C%20professional%20IT%20setup%2C%20clean%20technical%20environment%2C%20blue%20ambient%20lighting%2C%20data%20center%20aesthetic&width=800&height=800&seq=prod-nvr-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Closeup%20of%20NVR%20rear%20panel%20showing%20Ethernet%20ports%20and%20HDD%20bays%2C%20professional%20network%20equipment%2C%20clean%20studio%20background%2C%20technical%20detail%20photography%2C%20precision%20engineering&width=800&height=800&seq=prod-nvr-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Security%20monitoring%20room%20with%20multiple%20camera%20feeds%20displayed%20on%20large%20screens%2C%20professional%20surveillance%20operation%2C%20dim%20ambient%20lighting%2C%20technical%20security%20environment%20photography&width=800&height=800&seq=prod-nvr-g3&orientation=squarish",
    ],
    specs: [
      { label: "Kanali", value: "8 IP kanala" },
      { label: "Rezolucija", value: "Do 4K po kanalu" },
      { label: "HDD", value: "2× SATA do 20TB" },
      { label: "Kompresija", value: "H.265+ / H.264+" },
      { label: "AI", value: "Lice, vozilo, perimetar" },
      { label: "Mreža", value: "Gigabit Ethernet 2×" },
    ],
    features: [
      "Snimanje 8× 4K kamera",
      "AI analitika u realnom vremenu",
      "2 HDD slota (do 20TB)",
      "H.265+ kompresija",
      "HDMI + VGA izlaz",
    ],
    benefits: [
      { icon: "ri-hard-drive-2-line", title: "Do 20TB skladišta", desc: "Dva SATA slota. Mesecima kontinuiranog snimanja bez potrebe za brisanjem." },
      { icon: "ri-cpu-line", title: "AI na uređaju", desc: "Ugrađena AI analitika detektuje lica, vozila i perimetarske prelaske u realnom vremenu." },
      { icon: "ri-file-reduce-line", title: "H.265+ kompresija", desc: "Do 60% manje prostora za isti kvalitet videa u poređenju sa standardnim formatima." },
    ],
    isFeatured: false,
  },
];

export const productCategories = [
  { name: "Sve", slug: "sve", count: 10 },
  { name: "Kamere", slug: "kamere", count: 3 },
  { name: "Video zvona", slug: "video-zvona", count: 1 },
  { name: "Video interfoni", slug: "video-interfoni", count: 2 },
  { name: "Kontrola pristupa", slug: "kontrola-pristupa", count: 2 },
  { name: "Alarmni sistemi", slug: "alarmni-sistemi", count: 1 },
  { name: "Sistemi za snimanje", slug: "sistemi-za-snimanje", count: 1 },
];